"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SNARK_SCALAR_FIELD = void 0;
// / Prime field used for zero-knowledge snarks.
exports.SNARK_SCALAR_FIELD = 21888242871839275222246405745257275088548364400416034343698204186575808495617n;
